import { createApp } from "vue";
import router from "./router/index.js";
import App from "./App.vue";
// import api from "./services/api";

import "@/assets/styles/index.scss"; // global css
// import Antd from "ant-design-vue";
// import "ant-design-vue/dist/antd.css";

// // svg图标
// import "virtual:svg-icons-register";
// import ElementIcons from "@/plugins/svgicon";

// 导入element-plus和样式文件
import Element from "element-plus";
import "element-plus/dist/index.css";
import * as ElIcons from "@element-plus/icons";
import zhCn from "element-plus/es/locale/lang/zh-cn";
const app = createApp(App);

for (const name in ElIcons) {
  app.component(name, ElIcons[name]);
}

// 全局组件库
// app.use(ElementIcons);
// app.use(Antd);
app.use(router);
app.use(Element, {
  locale: zhCn,
});
// 挂载视图放在最后一步
app.mount("#app");

// // import Antd from 'ant-design-vue'
// import 'ant-design-vue/dist/antd.css';

// // 引入UI组件库
// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
// //

// console.log(ElementPlus)

// const app = createApp(App)
// // 使用组件
// app.use(ElementPlus)
// app.use(router)
// createApp(App).use(router).mount('#app')
// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
// app.use(ElementPlus)
// const app = Vue.createApp({
//   App
// })
